import React, { useMemo } from "react";
import ReactDatePicker from "react-datepicker";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import { ComonIcons } from "../../contents/commonIcons";
import {
  toggleClassEditModal,
  toggleClassCancelModal,
} from "../../redux/actions/class/classAction";
import Title from "../title";
import { editClass, getClass } from "../../redux/actions/api/apiAction";
import { useFormik } from "formik";
import moment from "moment";
import Select from "react-select";

const ClassEditModal = (props) => {
  const { selectedClassForEdit, classData } = useSelector(
    (state) => state.class
  );
  const { allTrainers } = useSelector((state) => state.trainer);
  const { gym } = useSelector((state) => state.gym);

  const dispatch = useDispatch();

  const customStyle = {
    control: (provided, state) => ({
      ...provided,
      background: "white",
      padding: 0,
      height: "auto",
      width: "100%",
      border: "none",
      boxShadow: "none",
      "&:hover": {
        border: "none",
        boxShadow: "none",
      },
    }),
  };

  const trainersList = useMemo(() => {
    return allTrainers.map((item) => {
      return { label: item.user_name, value: item.id };
    });
  }, []);

  React.useEffect(() => {
    if (selectedClassForEdit) dispatch(getClass(selectedClassForEdit.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClassForEdit]);

  const initialValues = {
    from: new Date(parseInt(selectedClassForEdit?.from)),
    to: new Date(parseInt(selectedClassForEdit?.to)),

    fromTime: moment(parseInt(selectedClassForEdit?.from)).format("HH:mm"),
    toTime: moment(parseInt(selectedClassForEdit?.to)).format("HH:mm"),

    capacity: selectedClassForEdit?.capacity,
    instructor: {
      label: selectedClassForEdit?.intialTrainer?.label,
      value: selectedClassForEdit?.intialTrainer?.value,
    },
  };

  const handleSubmit = (values) => {
    const fromDate = moment(values.from).clone();
    const [hours, minutes] = values.fromTime.split(":").map(Number);

    // Set the hours and minutes to the date
    fromDate.hours(hours);
    fromDate.minutes(minutes);
    const toDate = moment(values.to).clone();
    const [hoursTo, minutesTo] = values.toTime.split(":").map(Number);

    // Set the hours and minutes to the date
    toDate.hours(hoursTo);
    toDate.minutes(minutesTo);
    const req = {
      from: fromDate.valueOf(),
      to: toDate.valueOf(),
      instructor: values.instructor.value,
      id: selectedClassForEdit.id,
      startDate: props.startDate,
      trainer: props.trainer,
      capacity:values.capacity
    };
    dispatch(editClass(req));
  };

  const formik = useFormik({ initialValues, onSubmit: handleSubmit });

  console.log({initialValues}, "=========");

  return (
    <Modal
      isOpen={
        (props.loginUser.role === "STAFF" && !props.permissions["S-CD-E"]) ||
        (props.subAdminType === "SUB_ADMIN" &&
          !props.subAdminPermissions["S-CD-E"])
          ? false
          : props.classEditModal
      }
      toggle={() => props.toggleClassEditModal()}
      centered={true}
      size="md"
      className="large-pop adding-popup "
    >
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <div className="bg-white mx-3">
            <div className="d-flex align-items-center border-bottom-1 pb-4">
              <div className="d-inline-flex ">
                <Title
                  title="Edit Class Details"
                  subtitlestyle="ctf-tx-secondary"
                />
              </div>
              <div className="d-inline-flex ml-auto">
                <div className="close-icons pb-0">
                  <div className="text-right">
                    <span
                      className="svg-block"
                      onClick={(e) => props.toggleClassEditModal()}
                    >
                      {ComonIcons.closeBlack}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="py-4">
              <Row className="pb-2">
                <Col md={12} className="mb-4">
                  <Label for="startDate">{"Class Date"}</Label>
                  <FormGroup
                    className="custom-inputs mt-0 mb-md-0 "
                    style={{ marginTop: "26px" }}
                  >
                    <ReactDatePicker
                      name="from"
                      className="new-appointment-date"
                      selected={new Date(formik.values.from)}
                      autoComplete={false}
                      onChange={(date) => {
                        formik.setFieldValue("from", moment(date).valueOf());
                      }}
                      minDate={new Date().getTime()}
                      dateFormat="dd/MM/yyyy"
                      disabled={gym?.type == "sportClub"}
                    />
                  </FormGroup>
                </Col>

                <Col md={12} className="mb-4">
                  <FormGroup className="custom-inputs mt-0 mb-md-0 ">
                    <Input
                      type="number"
                      name="capacity"
                      id="Class Capacity &#9733;"
                      placeholder={"Class Capacity"}
                      className={`form-control `}
                      value={formik?.values?.capacity}
                      min={0}
                      onChange={(event) => {
                        formik.setFieldValue("capacity", parseInt(event.target.value));
                      }}
                    />

                    <Label for="capacity" className="">
                      {gym.type == "sportClub"
                        ? "Group Session Capacity"
                        : "Class Capacity "}
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup className="custom-inputs select-box mb-md-0 ">
                    <Input
                      type="time"
                      onChange={(event) => {
                        console.log({ event });
                        formik.setFieldValue("fromTime", event.target.value);
                      }}
                      id={"from"}
                      name="from"
                      className={`form-control input time-input `}
                      value={formik.values.fromTime}
                    />

                    <Label for="to" className="">
                      {gym.type == "sportClub"
                        ? "Group Session Start Time"
                        : "Class Start Time"}
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup className="custom-inputs mt-0 mb-md-0 ">
                    <Input
                      type="time"
                      onChange={(event) => {
                        formik.setFieldValue("toTime", event.target.value);
                      }}
                      id={"to"}
                      name="to"
                      className={`form-control input time-input `}
                      value={formik.values?.toTime}
                    />

                    <Label for="to" className="">
                      {gym.type == "sportClub"
                        ? "Group Session End Time"
                        : "Class End Time"}
                    </Label>
                  </FormGroup>
                </Col>
                <Col md={12} className="mt-1">
                  <Label for="instructor">{"Instructor"}</Label>
                  <FormGroup
                    className="custom-inputs mt-0 mb-md-0 "
                    style={{ marginTop: "26px" }}
                  >
                    <Select
                      name="instructor"
                      className={`form-control p-0 h-100 d-flex align-items-center`}
                      options={trainersList}
                      value={formik.values.instructor}
                      onChange={(value) =>
                        formik.setFieldValue("instructor", {
                          label: value.label,
                          value: value.value,
                        })
                      }
                      styles={customStyle}
                      defaultValue={formik.values.instructor}
                    />
                  </FormGroup>
                </Col>
                <Col md={12} className="mt-4">
                  <span
                    onClick={() => {
                      props.toggleClassCancelModal(selectedClassForEdit);
                      props.toggleClassEditModal();
                    }}
                    className="red-link"
                  >
                    {gym?.type == "sportClub"
                      ? "Cancel this slot"
                      : "Cancel this class"}
                  </span>
                </Col>
              </Row>
            </div>
          </div>
          <Row className="my-2 mx-0">
            <Col xs={12}>
              <button type="submit" className="btn-small btn w-100">
                Save Changes
              </button>
            </Col>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const { classData, classEditModal } = state.class;
  const { loginUser } = state.login;
  const { permissions, subAdminType, subAdminPermissions } = state.permissions;
  return {
    classData,
    loginUser,
    permissions,
    classEditModal,
    subAdminType,
    subAdminPermissions,
  };
};

export default connect(mapStateToProps, {
  toggleClassEditModal,
  toggleClassCancelModal,
})(ClassEditModal);
